// @flow
import React from 'react';
import { Link } from '@i18n';
import type { WraperWithLinkProps } from './types';

const WrapWithLink = ({
  children, doWrap, route, params
}: WraperWithLinkProps) => {
  if (doWrap) {
    return (
      <Link href={route} params={params} passHref>
        {children}
      </Link>
    );
  }
  return <>{children}</>;
};

export default WrapWithLink;
